import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AuthService } from '@spartacus/core';
import { combineLatest, Observable, filter, take } from 'rxjs';
import { LegalEntity } from '../../../SGRE-shared/models/legalEntityList.model';
import { GlobalService } from '../../../SGRE-shared/services/global.service';
import { StorageService } from '../../../SGRE-shared/services/storage.service';
import * as StorageActions from '../../../SGRE-shared/store/shared-store/actions/browser-storage.action';
import { selectDefaultLegalEntity } from '../../../SGRE-shared/store/shared-store/selectors/shared.selector';
import { CustomProduct } from '../../product-list-page/models/custom-product.model';
import { HomePageConstants } from '../models/homepage.model';
import * as categoriesAction from '../store/action/fetch-categories.action';
import * as topFeaturedProductsAction from '../store/action/fetch-topFetaureProduct.action';
import * as fetchCarouselActions from '../store/action/fetch_carousel_image.action';
import { itemState } from '../store/homepage.state';
import { selectCarouselImages, categoriesSelector, selectTopFeaturedProducts } from '../store/selector/homepage.selector';
import { fetchProductPriceAction } from '../store/action/fetch-topFeatureProductPrice.action';

@Injectable({
  providedIn: 'root'
})
export class HomepageService {

  // private imageList = new BehaviorSubject<any[]>([]);
  // data$ = this.imageList.asObservable();

  // private categoriesListSubject = new BehaviorSubject<any>(null);
  // dataCat$ = this.categoriesListSubject.asObservable();

  // private featuredProductListSubject = new BehaviorSubject<any>(null);
  // featuredProduct$ = this.featuredProductListSubject.asObservable();
  selectedLegalEntitySession: LegalEntity;

  constructor(
    private globalService: GlobalService,
    private store: Store,
    private storageService: StorageService,
    private authService: AuthService,
  ) { }

  //////OOTB implementation/////////////
  fetchCarouselImages(bannersImages: string[]): void {
    this.store.dispatch(fetchCarouselActions.fetchCarouselImagesAction({ bannersImages }));
  }

  getCarouselImages(): Observable<string[]> {
    return this.store.pipe(
      select(selectCarouselImages),
      filter(data => data != null)
    );
  }

  updateCarouselImages(activeIndex: number): void {
    this.store.dispatch(fetchCarouselActions.updateCarouselImages({ activeIndex }));
  }

  public getCategoriesAPI(): void {
    const paramsObject = { fields: HomePageConstants.FULL }
    this.store.dispatch(categoriesAction.fetchCategoriesAction({ paramsObject }))
  }

  getCategories(): Observable<itemState[]> {
    return this.store.pipe(select(categoriesSelector))
  }

  setQueryToStorage(queryVal: string): void {
    this.store.dispatch(StorageActions.setQuery({ query: queryVal }));
  }

  public loadTopFeaturedProducts(): void {
    combineLatest([
      this.authService.isUserLoggedIn(),
      this.store.pipe(select(selectDefaultLegalEntity)),
    ])
      .pipe(
        filter(([isLoggedIn, defaultLegalEntity]) =>
          !isLoggedIn || !!defaultLegalEntity?.name
        ),
        take(1),
      )
      .subscribe(() => {
        this.store.dispatch(
          topFeaturedProductsAction.fetchTopProductsAction({
            currentPage: 0,
            fields: HomePageConstants.FULL,
            pageSize: 20,
          }),
        );
      });
  }

  getTopFeaturedProducts(): Observable<CustomProduct[]> {
    return this.store.pipe(select(selectTopFeaturedProducts))
  }

  fetchProductPriceForCode(productCode: string): void {
    this.store.dispatch(fetchProductPriceAction({ productCodes: [productCode] }));
  }

  ///////old implementation////////
  // public getCategoriesAPI() {
  //   let paramsObject = { fields: 'FULL' }

  //   this.apiService.getHomePageCategories(paramsObject)
  //     .subscribe({
  //       next: (data: any) => {
  //         const filteredData = data.categories.filter(item => item.code != 'TOP FEATURED PRODUCTS');
  //         this.categoriesListSubject.next(filteredData);
  //       }
  //     });
  // }

  // getCarouselImages(banners: string[]) {
  //   of(banners)
  //     .pipe(
  //       mergeMap((banner: string[]) => {
  //         let fields = 'DEFAULT';
  //         let currentPage = 0;
  //         let pageSize = banners.length;

  //         return forkJoin(
  //           banner.map((b) => {
  //             return this.apiService.getCarouselImagesHome(fields, currentPage, pageSize, b)
  //           })
  //         );
  //       })
  //     )
  //     .subscribe((data) => this.imageList.next(data));
  // }

  // public getFeaturedProductList() {
  //   const userId = this.globalService.getUserId();
  //   this.store.pipe(select(selectDefaultLegalEntity)).subscribe((defaultLegalEntity) => {
  //     this.selectedLegalEntitySession = defaultLegalEntity ? defaultLegalEntity : '';
  //   });
  //   if (this.selectedLegalEntitySession.name || userId == 'anonymous') {
  //     this.apiService.getTopFeaturedProductList(0, 'FULL', 20).subscribe({
  //       next: (data) => this.featuredProductListSubject.next(data),
  //       error: (error) => console.log("Error from Featured Product Service")
  //     });
  //   } else {
  //     this.featuredProductListSubject.next({ products: [] })
  //   }
  // }
}
